import React from 'react';
import moment from "moment";
import { api } from "common";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { Column } from "material-table";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { IUserType, IWithdrawType } from "common/src/types";
import { CustomMaterialTable } from "components/CustomMaterialTable";


function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`withdraw-tabpanel-${index}`}
      aria-labelledby={`withdraw-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `withdraw-tab-${index}`,
    'aria-controls': `withdraw-tabpanel-${index}`,
  };
}

interface WithdrawTableProps {
  type: IUserType['usertype'];
}

const WithdrawTable = ({ type }: WithdrawTableProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { completeWithdraw } = api;
  const withdrawdata = useSelector((state) => state.withdrawdata);
  const settings = useSelector((state) => state.settingsdata.settings);

  if (!settings) return null;

  const columns: Column<IWithdrawType>[] = [
    {
      field: "id",
      title: t("ID_USER"),
    },
    {
      field: "date",
      title: t("requestDate"),
      render: (rowData) => rowData.date ? moment(rowData.date).format('DD/MM/YYYY HH:mm') : null
    },
    {
      title: t("name"),
      field: "name",
    },
    {
      field: "amount",
      title: t("amount"),
    },
    {
      type: "boolean",
      field: "processed",
      title: t("processed"),
    },
    {
      field: "processDate",
      title: t("processDate"),
      render: (rowData) => rowData.processDate ? moment(rowData.processDate).format('DD/MM/YYYY HH:mm') : null,
    },
    {
      title: t("bankName"),
      field: "bankName",
    },
    {
      field: "bankCode",
      title: t("bankCode"),
    },
    {
      field: "bankAccount",
      title: t("bankAccount"),
    },
    {
      field: "pix_key",
      title: t("PIX"),
    },
  ];

  const filteredData = withdrawdata.withdraws?.filter((user) => {
    if (type === 'driver') {
      return user.usertype === 'driver' || user.usertype === null || !user.usertype;
    } else {
      return user.usertype === 'customer';
    }
  }) ?? [];

  return (
    <CustomMaterialTable
      columns={columns}
      data={filteredData}
      isLoading={withdrawdata.loading}
      title={type === 'driver' ? t("DRIVER_PICKUPS") : t("PASSENGER_PICKUPS") as any}
      options={{
        rowStyle: (rowData) => {
          if (!rowData.processed) {
            return {
              filter: "drop-shadow(0 0 10px red)",
            };
          }
          return {};
        },
      }}
      actions={[
        (rowData) => ({
          icon: "check",
          tooltip: t("process_withdraw"),
          disabled: rowData.processed,
          onClick: (event, rowData) => {
            dispatch(completeWithdraw(rowData as any));
          },
        }),
      ]}
    />
  );
};

const Withdraws = () => {
  const { t } = useTranslation();
  const [value, setValue] = React.useState(0);

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          aria-label="withdraw type tabs"
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
        >
          <Tab
            label={t("DRIVER_PICKUPS")}
            style={{ marginRight: "20px" }}
            {...a11yProps(0)}
          />
          <Tab
            label={t("PASSENGER_PICKUPS")}
            style={{ marginRight: "20px" }}
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <WithdrawTable type="driver" />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <WithdrawTable type="customer" />
      </TabPanel>
    </Box>
  );
};

export default Withdraws;